import { overlay } from 'overlay-kit';

import { DiscoverySaveToListDialog } from './discovery-save-to-list-dialog';
import type { DiscoverySaveToListResult } from './discovery-save-to-list-dialog-types';

export function showDiscoverySaveToListDialog(
  initialTitle: string,
): Promise<DiscoverySaveToListResult> {
  return new Promise((resolve) => {
    overlay.open(({ isOpen, close }) => {
      if (!isOpen) return null;

      const handleSave = (result: DiscoverySaveToListResult) => {
        resolve(result);
        close();
      };

      return (
        <DiscoverySaveToListDialog
          close={() => {
            resolve({ action: 'cancel' });
            close();
          }}
          initialTitle={initialTitle}
          isOpen={isOpen}
          onSave={handleSave}
        />
      );
    });
  });
}
